import { Box, Divider, Typography } from "@mui/material";

import NewEditIcon from "../Icons/NewEditIcon";
import { ExpressServiceIcon } from "../Icons";
import React, { useState } from "react";
import { ReasonForVisitContainerStyled } from "../../shared/containers/BookingReviewContainer/BookingReviewStyle";
import { formatReasonString } from "../../shared/containers/AppointmentReviewContainer/AppointmentReviewContainer";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { getExpressFormatSocString } from
  "../../shared/containers/BookingReviewContainer/ExpressBookingReviewContainer";
import { MIXPANEL_EVENTS } from "../../config/mixPanelEvents";
import { userActivityLogger } from "../../utils/mixpanel";

import { getFormattedReasons } from "../../utils/bookingFlow";
import { IAppointmentCreateResponse } from "../../services/create-appointment-v2/create-appointment-v2.interface";
interface IExpressBookingReviewDetails{
  setActiveStep?: (val: number) => void;
  modal: "BookingReview" | "BookingConfirmation" | "AppointmentReview";
  setReasonUpdatePetIndex?: (index: number) => void;

}

const ExpressBookingReviewDetails = ({
  setActiveStep,
  modal,
  setReasonUpdatePetIndex }: IExpressBookingReviewDetails) => {
  const { appointmentDetails, appointmentsResponse, appointmentsRescheduleResponse, selectedPets, reasonForVisit,
    setReasonForVisit } = useAppointmentStore();
  // eslint-disable-next-line no-unused-vars
  const [visit, setVisit] =
      useState<IAppointmentCreateResponse | null>(appointmentsResponse || appointmentsRescheduleResponse);
  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toLocaleUpperCase() + string.substring(1);
  };


  const getFormatSocString = (socReasons: string[]) => {
    const formattedHTML: JSX.Element[] = [];

    socReasons.map((reasons, i) => {
      const splitReasons = reasons.split(":");

      if (splitReasons.length > 1) {
        formattedHTML.push(<React.Fragment key={i}>
          <span className="font-semibold capitalize">
            {splitReasons[0] == "reasons" ? "Other": splitReasons[0]}:
          </span>
          <span className="font-normal"><br />{splitReasons[1].replaceAll(",", ", ")}</span>
          <br />
          {i !== socReasons.length-1 && <Divider className="!opacity-100 !my-0.5" />}
        </React.Fragment>);
      } else if (splitReasons.length == 1) {
        formattedHTML.push(<React.Fragment key={i}>
          <span className="font-semibold capitalize">Other:<br /></span>
          <span className="font-normal">{splitReasons[0].replaceAll(",", ", ")}</span>
          <br />
        </React.Fragment>);
      }
    });

    return formattedHTML;
  };

  return (
    <ReasonForVisitContainerStyled className={`!w-full !border-none
     ${modal==="BookingConfirmation" || modal==="AppointmentReview" ? undefined: "!p-4"}`}>

      <div className="min-w-[25px]">
        <div className="h-fit w-fit flex items-center justify-center bg-taupe-4 rounded-full p-1">
          <ExpressServiceIcon width={17} height={17} />
        </div>
      </div>

      <Box className="childContainer">
        {modal === "BookingReview" && selectedPets.map((info, index) => (
          <Box className="flex flex-col w-full grow mb-1" key={index}>
            {selectedPets.length>1 &&
            <Typography variant="body1" color="#908E8D">
              {capitalizeFirstLetter(info.name)}
            </Typography>}
            <Typography variant="h4" fontWeight={600}>
              <p>
                {reasonForVisit[info.id].socReasons &&
              reasonForVisit[info.id].socReasons.toString().length ?
                  getFormatSocString(reasonForVisit[info.id].socReasons) :
                  ""}
              </p>
              {reasonForVisit[info.id].reasons &&
            <p>
              {reasonForVisit[info.id].socReasons?.toString() &&
                <Divider className="!opacity-100 !my-0.5" />
              }
              <span className="font-semibold">
                {"Express Services: "}
              </span>
              <br />
              <span className="font-normal">
                {getFormattedReasons(reasonForVisit[info.id].reasons)}
              </span>
            </p>}
              <p>
                {!reasonForVisit[info.id].reasons &&
              !reasonForVisit[info.id].socReasons.toString() ?
                  "General Care" :
                  ""}
              </p>
            </Typography>
          </Box>
        ))}
        {modal === "BookingConfirmation" && visit && (
          visit?.pets.length > 1 ? (
            visit?.pets?.map((pet) => (
              <Box className="flex flex-col gap-1" key={pet.id}>
                <Typography variant="body1" className="!text-gray-1">{capitalizeFirstLetter(pet.name)}</Typography>
                <Typography className="!text-base !font-semibold">
                  {
                    getExpressFormatSocString(formatReasonString(pet?.reasonForVisit))
                  }
                </Typography>
              </Box>
            ))
          ) : (
            <div className="flex flex-col">
              <Typography className="!text-base !font-semibold">
                {
                  getExpressFormatSocString(formatReasonString(visit?.pets?.[0].reasonForVisit))
                }
              </Typography>
            </div>
          )
        )}

        {modal === "AppointmentReview" && appointmentDetails &&(
          <Box className="max-w-full">
            <Box className="flex flex-col">
              <Typography variant="h4" className="!capitalize " fontWeight={600}>
                {
                  getExpressFormatSocString(formatReasonString(appointmentDetails?.reasonsForVisit))
                }</Typography>
            </Box>
          </Box>
        ) }

      </Box>
      {setActiveStep && <Box
        className="grow flex justify-end items-center mt-2 cursor-pointer"
        onClick={() =>{
          if (modal === "BookingReview") {
            setReasonUpdatePetIndex && setReasonUpdatePetIndex(1);
            setReasonForVisit({});

            userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_EDIT_DETAILS,
              { pet_name: selectedPets.map((pet) => pet.name).join(","),
                type: "edit_reason",
                appt_type: "express_visit",
              });
            setActiveStep(1);
          }
        }}
      >
        <NewEditIcon />
      </Box>}
    </ReasonForVisitContainerStyled>
  );
};

export default ExpressBookingReviewDetails;
